import { http } from '../../config/axios'

export default function getPerfilPermissoes(idPerfil: string): Promise<any[]> {
  return http
    .get('api/perfil/permissoes/' + encodeURIComponent(idPerfil))
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getPerfilPermissoes', error)
      throw Error(error.response.data)
    })
}
